import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import { useInViewOnce } from "../../hooks/useInViewOnce";

const OFFSET = {
  up: "translateY(28px)",
  left: "translateX(-28px)",
  right: "translateX(28px)",
};

export const revealDelay = (index, step = 80) => index * step;

const MarketingReveal = ({
  children,
  delay = 0,
  direction = "up",
  sx = {},
}) => {
  const reduceMotion = useMediaQuery("(prefers-reduced-motion: reduce)");
  const { ref, inView } = useInViewOnce({ disabled: reduceMotion });
  const shown = reduceMotion || inView;

  return (
    <Box
      ref={ref}
      sx={{
        opacity: shown ? 1 : 0,
        transform: shown ? "none" : OFFSET[direction] || OFFSET.up,
        transition: reduceMotion
          ? "none"
          : [
              `opacity 720ms cubic-bezier(0.16, 1, 0.3, 1) ${delay}ms`,
              `transform 720ms cubic-bezier(0.16, 1, 0.3, 1) ${delay}ms`,
            ].join(", "),
        "@media (prefers-reduced-motion: reduce)": {
          opacity: 1,
          transform: "none",
          transition: "none",
        },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default MarketingReveal;
